import React, { useEffect, useContext, useState, useMemo } from 'react';
import Badge from '../../../components/base/Badge';
import RevealDropdown, {
  RevealDropdownTrigger
} from '../../../components/base/RevealDropdown';
import { useMainLayoutContext } from '../../../providers/MainLayoutProvider';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { UilStopwatch } from '@iconscout/react-unicons';
import TaskCompletedGant from '../../../components/project-management/project-details/TaskCompletedGant';
import WorkLoads from '../../../components/project-management/project-details/WorkLoads';
import ConsumptionDetails from '../../production-management/ConsumptionDetails';
import TeamMembers from '../../../components/project-management/project-details/TeamMembers';
import ProjectDetailsSummary from '../../../components/project-management/project-details/ProjectDetailsSummary';
import ActivityTimeline from '../../../components/timelines/ActivityTimeline';
import { activityTimelineData } from '../../../data/project-management/activityTimelineData';
import MachineCounterChart from '../../../components/charts/machines-charts/MachineTotalProduction.js';
import Ach300MaxSpeedAndLinearSpeed from '../../../components/charts/machines-charts/MachineMaxSpeedAndLinearSpeed';
import MachineSpeedGauge from '../../../components/charts/machines-charts/MachineSpeedGauge';
import MachineTotalMetersChart from '../../../components/charts/machines-charts/MachineTotalMetersChart';
import MachinePowerPercentageGauge from '../../../components/charts/machines-charts/MachinePowerPercentageGauge';
import MachineTempZonesChart from '../../../components/charts/machines-charts/MachineTempZonesChart';
import MachineDiameterChart from '../../../components/charts/machines-charts/MachineDiameterChart';
import MachineAmpsGraph from '../../../components/charts/machines-charts/MachineAmpsGraph';
import { FidgetSpinner } from 'react-loader-spinner';
import { useAppContext } from '../../../providers/AppProvider';
import MachinePercentageLineChart from '../../../components/charts/machines-charts/MachinePercentageLineChart';
import getShiftStartEndTime, {
  updateTimeRange
} from '../../../components/charts/utils/chartUtils';
import MachineMaxActCounterChart from '../../../components/charts/machines-charts/MachineMaxActCounterChart';
import MachineDoubleLineChart from '../../../components/charts/machines-charts/MachineDoubleLineChart';
import MachimeTime from '../../../components/cards/MachimeTime.js';
import MachineTotalProduction from '../../../components/charts/machines-charts/MachineTotalProduction.js';
import ActiveBreakTimeBarChart from '../../../components/charts/machines-charts/ActiveBreakTimeBarChart.js';
import DiameterSetTotalProduced from '../../../components/charts/machines-charts/DiameterSetTotalProduced.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleRight,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import DisplayShift from '../../../components/base/DisplayShift.js';
import LazyLoadChart from '../../../components/common/LazyLoadChart.js';

import MachineModeStatus from '../../../components/base/MachineModeStatus.js';
import { WebSocketContext } from '../../../providers/WebSocketProvider.js';
import '../../../components/machines/trackingHeader.css';

const L120Traking = () => {
  const { setContentClass } = useMainLayoutContext();

  const { machineSingle, subscribeToChannel, unsubscribeToChannel } =
    useContext(WebSocketContext);

  console.log('Machine Single from context: ', machineSingle);

  useEffect(() => {
    setContentClass('px-0 pt-navbar');

    return () => {
      setContentClass('');
    };
  }, []);

  const initialShiftTimes = getShiftStartEndTime();
  const currentDay = dayjs();

  // State for startTime and endTime
  const [timeRange, setTimeRange] = useState({
    startTime: initialShiftTimes.startTime,
    endTime: initialShiftTimes.endTime
  });

  const reversedReports = useMemo(
    () =>
      machineSingle?.state?.reports
        ? machineSingle.state.reports.slice().reverse()
        : [],
    [machineSingle?.state?.reports]
  );

  const { startTime, endTime } = timeRange;
  const isWithinShift = currentDay.isBetween(
    dayjs(timeRange.startTime),
    dayjs(timeRange.endTime)
  );

  // Function to update the time range by a specific amount
  const handleUpdate = direction => {
    const { startTime, endTime } = updateTimeRange(timeRange, direction);

    setTimeRange(prevRange => ({
      startTime,
      endTime
    }));
  };
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  useEffect(() => {
    console.log('Subscribing to machine-all channel');
    subscribeToChannel('machine-single', 'l120');

    return () => {
      console.log('UNSUBSCRIBING from machine-all channel');
      unsubscribeToChannel();
    };
  }, []);

  if (!machineSingle || machineSingle.machine !== 'l120') {
    return (
      <div style={styles.spinnerContainer}>
        <FidgetSpinner
          // backgroundColor = {theme === "dark" ? 	["#ff0000", "#00ff00", "#0000ff"] : 	["#ff0000", "#00ff00", "#3874ff""]}
          backgroundColor={theme === 'dark' ? 'white' : '#3874ff'}
          height="80"
          width="80"
          visible={true}
          ariaLabel="fidget-spinner-loading"
          // wrapperStyle ={styles.spinnerContainer}
        />
      </div>
    );
  }
  return (
    <Row className="g-0 border-bottom border-300">
      <Col xs={12} xxl={isWithinShift ? 8 : 12} className="px-0 bg-soft">
        <div className="px-4 px-lg-6 pt-6 pb-9">
          <div className="mb-5">
            <div className="tracking-header">
              {/* Machine Overview */}
              <h2 className="text-black fw-bolder mb-2 tracking-header__title">
                Machine L120 overview
              </h2>

              {/* Timeline: Center-aligned */}
              <div
                className="d-flex align-items-center mx-auto"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <button
                  className="btn btn-link p-0"
                  aria-label="Previous date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    console.log('LEFT CLICK');
                    handleUpdate(-1);
                  }} // Decrease by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  {dayjs(startTime).format('MMMM D, YYYY, h:mm A')}
                </span>
                <button
                  className="btn btn-link p-0"
                  aria-label="Next date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    handleUpdate(1);
                    console.log('RIGHT CLICK');
                  }} // Increase by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
              </div>
              {/* Right half — sizing lives in trackingHeader.css */}
              <div className="tracking-header__aside">
                <DisplayShift
                  machineName={'l120'}
                  bucket={'machine_data'}
                  startTime={startTime}
                  endTime={endTime}
                />

                <RevealDropdownTrigger>
                  <RevealDropdown>
                    <Dropdown.Item>Edit</Dropdown.Item>
                    <Dropdown.Item className="text-danger">Delete</Dropdown.Item>
                    <Dropdown.Item>Download</Dropdown.Item>
                    <Dropdown.Item>Report abuse</Dropdown.Item>
                  </RevealDropdown>
                </RevealDropdownTrigger>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <Badge
                variant="phoenix"
                bg={machineSingle.state.status.type}
                iconPosition="end"
                icon={<UilStopwatch size={12} className="ms-1" />}
              >
                {machineSingle.state.status.label}
              </Badge>

              <MachineModeStatus
                bucket="machine_data"
                machineName="l120"
                startTime={startTime}
                endTime={endTime}
              />
            </div>
          </div>
          <Row className="gx-0 gx-sm-5 gy-8 mb-8">
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalProduction
                  bucket={'machine_data'}
                  machineName={'l120'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              <LazyLoadChart>
                <DiameterSetTotalProduced
                  bucket={'machine_data'}
                  machineName={'l120'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Length produced by jacketing diameter'}
                  field={'JACKETING_SET_DIA'}
                  // Only metres made while the jacketing laser was measuring.
                  // The two extruders run independently and an idle line keeps
                  // its last setpoint, so without this a filler-only run was
                  // credited to a jacketing diameter it never touched.
                  gate={'JACKETING_DIA_ON_OFF'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              <LazyLoadChart>
                <DiameterSetTotalProduced
                  bucket={'machine_data'}
                  machineName={'l120'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Length produced by filler diameter'}
                  field={'FILLING_SET_DIA'}
                  gate={'FILLING_DIA_ON_OFF'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  bucket={'machine_data'}
                  machineName={'l120'}
                  time={'totalActiveTime'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  bucket={'machine_data'}
                  machineName={'l120'}
                  time={'totalBreakTime'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={12} xxl={12} className="pe-xl-0">
              <LazyLoadChart>
                <ActiveBreakTimeBarChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_30minute'}
                  machineName={'l120'}
                  fields={'ACTIVE_TIME,BREAK_TIME'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Active Break Time'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalMetersChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'total_produced'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Line Speed'}
                  speed={machineSingle.state.currentPlcState.LINE_SPEED_ACT.toFixed(
                    2
                  )}
                />
              )}
            </Col>
            <Col xs={12} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  title={'Line Speed'}
                  machineName={'l120'}
                  fields={'LINE_SPEED_ACT'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Master Percentage'}
                  speed={machineSingle.state.currentPlcState.ACT_RAMP_VALUE.toFixed(
                    2
                  )}
                />
              )}
            </Col>
            <Col xs={12} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Master Percentage'}
                  machineName={'l120'}
                  fields={'ACT_RAMP_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── EXTRUDER F + J — Screw RPM (side by side) ───── */}
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Filler Screw RPM (E-120/F)'}
                  machineName={'l120'}
                  fields={'E120_F_SCREW_ACT_RPM'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Jacketing Screw RPM (E-120/J)'}
                  machineName={'l120'}
                  fields={'E120_J_SCREW_ACT_RPM'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── EXTRUDER F + J — Pornire / referinta % (side by side) ───── */}
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Filler Extruder % (E-120/F)'}
                  machineName={'l120'}
                  fields={'E120_F_ACT_PERCENTEC_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Jacketing Extruder % (E-120/J)'}
                  machineName={'l120'}
                  fields={'E120_J_ACT_PERCENTEC_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── DIAMETER F + J — set / act laser (side by side) ───── */}
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineDiameterChart
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'FILLING_SET_DIA,FILLING_DIA_ACT_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Filler Laser — diameter'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineDiameterChart
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'JACKETING_SET_DIA,JACKETING_DIA_ACT_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Jacketing Laser — diameter'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12}>
              <LazyLoadChart>
                <MachineMaxActCounterChart
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'METER_ACT'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── EXTRUDER F + J — Current (side by side) ───── */}
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'E120_F_CURRENT_ACT'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Filler extruder current (E-120/F)'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'E120_J_CURRENT_ACT'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Jacketing extruder current (E-120/J)'}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── ENTRY + EXIT CATERPILLAR — Current (side by side) ───── */}
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'ENTRY_CAT_CURRENT'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Entry caterpillar current'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'l120'}
                  fields={'EXIT_CAT_CURRENT'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Exit caterpillar current'}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── PULLING PERCENTAGE — Entry + Exit caterpillar (side by side) ───── */}
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Entry caterpillar pulling %'}
                  machineName={'l120'}
                  fields={'ENTRY_CAT_ACT_PERCENTEC_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Exit caterpillar pulling %'}
                  machineName={'l120'}
                  fields={'EXIT_CAT_ACT_PERCENTEC_VALUE'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            {/* ───── TEMP ZONES F + J (side by side) ───── */}
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineTempZonesChart
                  bucket={'machine_data_minute'}
                  title={'Filler temp zones (E-120/F)'}
                  machineName={'l120'}
                  fields={
                    'E120_F_ACT_TEMP_WZ,E120_F_ACT_TEMP_Z1,E120_F_ACT_TEMP_Z2,E120_F_ACT_TEMP_Z3,E120_F_ACT_TEMP_Z4,E120_F_ACT_TEMP_Z5,E120_F_ACT_TEMP_CLAMP,E120_F_ACT_TEMP_ADAPTOR,E120_F_ACT_TEMP_HEAD1,E120_F_ACT_TEMP_HEAD2'
                  }
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineTempZonesChart
                  bucket={'machine_data_minute'}
                  title={'Jacketing temp zones (E-120/J)'}
                  machineName={'l120'}
                  fields={
                    'E120_J_ACT_TEMP_WZ,E120_J_ACT_TEMP_Z1,E120_J_ACT_TEMP_Z2,E120_J_ACT_TEMP_Z3,E120_J_ACT_TEMP_Z4,E120_J_ACT_TEMP_Z5,E120_J_ACT_TEMP_CLAMP,E120_J_ACT_TEMP_ADAPTOR,E120_J_ACT_TEMP_HEAD1,E120_J_ACT_TEMP_HEAD2'
                  }
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
          </Row>
        </div>
      </Col>
      {isWithinShift ? (
        <Col xs={12} xxl={4} className="px-0 border-start-xxl border-300">
          <div className="border-bottom border-300">
            <div className="bg-light dark__bg-1100 h-100">
              <div className="p-4 p-lg-6">
                <h3 className="text-1000 mb-4 fw-bold">Recent activity</h3>
                <ActivityTimeline reports={reversedReports} />
              </div>
            </div>
          </div>
        </Col>
      ) : (
        ''
      )}
    </Row>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default L120Traking;
